<template>
  <div class="container">
    <template v-if="editing">
      <smartVoiceEdit
        :voice="voice"
        :readerOpts="readerOpts"
        :readerTabs="readerTabs"
        :reader="reader"
        :readerId="readerId"
        @cancel="cancelEdit"
        @updateReader="updateReader"
      ></smartVoiceEdit>
    </template>
    <template v-else>
      <div class="content">
        <div class="reader">
          <div class="figure">
            <img :src="$handleAssetsUrl(readerData.iconUrl)" alt />
          </div>
          <div class="label">{{ readerData.label }}</div>
        </div>
        <div class="text-wrapper">
          {{ voice.text }}
        </div>
        <div class="control"></div>
        <div class="test-play-row">
          <div class="test-play" @click="testPlay">
            <div class="figure">
              <svg
                viewBox="0 0 1024 1024"
                width="36"
                height="36"
                v-show="!playing"
              >
                <circle id="gfg" cx="512" cy="512" r="512" fill="#5778FB" />
                <path
                  d="M398.222222 307.768889v408.462222c0 19.911111 29.013333 30.72 47.217778 17.635556l284.444444-204.231111a20.48 20.48 0 0 0 0-34.702223l-284.444444-204.8c-18.204444-13.084444-47.217778-2.275556-47.217778 17.635556z"
                  fill="#FFFFFF"
                  p-id="3227"
                ></path>
              </svg>
              <svg
                v-show="playing"
                class="icon"
                style="
                  width: 36px;
                  height: 36px;
                "
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle id="gfg" cx="512" cy="512" r="512" fill="#5778FB" />
                <path
                  d="M369.777778 284.444444m42.666666 0l0 0q42.666667 0 42.666667 42.666667l0 369.777778q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666666-42.666667l0-369.777778q0-42.666667 42.666666-42.666667Z"
                  fill="#FFFFFF"
                  p-id="4794"
                ></path>
                <path
                  d="M568.888889 284.444444m42.666667 0l0 0q42.666667 0 42.666666 42.666667l0 369.777778q0 42.666667-42.666666 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-369.777778q0-42.666667 42.666667-42.666667Z"
                  fill="#FFFFFF"
                  p-id="4795"
                ></path>
              </svg>
            </div>
            <div class="label">
              试听<span v-if="getDur()">（{{ getDur() }}s）</span>
            </div>
          </div>
        </div>
        <audio
          ref="audioEl"
          style="position: absolute; width: 0; height: 0"
          :src="voice && $handleAssetsUrl(voice.url)"
        ></audio>
      </div>
      <div class="footer">
        <div class="btn-remove" @click="remove">删除</div>
        <div class="btn-edit" @click="editing = true">编辑</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import smartVoiceEdit from './smartVoiceEdit.vue';
export default {
  props: {
    smartVoiceData: {

    }
  },
  components: {
    smartVoiceEdit
  },
  data () {
    return {
      editing: false,
      readerOpts: [],
      readerData: {},
      voice: {},
      readerTabs: [],
      playing: false
    }
  },
  computed: {
    ...mapGetters({
      getSelectDubbing: "addSoundtrack/getSelectDubbing",
      voiceWorksList: 'smartVoice/worksList'
    }),
    duration () {
      return (this.getSelectDubbing.cut[1] - this.getSelectDubbing.cut[0]).toFixed(1) - 0;
    },
    reader: {
      get () {
        return this.readerData.value
      },
      set (val) {
        this.readerData = this.readerOpts.find(v => v.value === val);
      }
    },
    readerId: {
      get () {
        return this.readerData.id
      },
      set (val) {
        this.readerData = this.readerOpts.find(v => v.id === val);
      }
    }
    // voice () {
    //   let item = this.voiceWorksList.find(v => v.url === (this.getSelectDubbing || {}).url);
    //   return item;
    // }
  },
  watch: {
    // getSelectDubbing (val) {
    //   this.getReader();
    // },
    // voice (val) {
    //   this.getReader();
    // }
    voiceWorksList () {
      this.getReaders();
    },
    smartVoiceData () {
      this.getReader();
    }
  },
  mounted () {
    this.getReaders();
  },
  methods: {
    getReaders () {
      let readers = this.$store.getters['smartVoice/readers'];
      if (readers.length) {
        this.readerOpts = readers;
        this.getReader();
        this.getReaderTabs();
      } else {
        this.$http
          .get("/api/user/audioAI/source")
          .then(res => {
            let { data } = res.data;
            this.readerOpts = data.map(read => {
              return {
                ...read,
                value: read.sourceId,
                label: read.sourceName
              };
            });

            this.getReader();
            this.getReaderTabs();
            this.$store.commit('smartVoice/setReaders', this.readerOpts);
          })
          .catch(this.err);
      }
    },
    getReader () {
      this.voice = this.smartVoiceData || this.voiceWorksList.find(v => v.url === (this.getSelectDubbing || {}).url) || {};
      const readerId = this.voice.speakerId;
      this.readerData = this.readerOpts.find(v => readerId ? v.id === readerId : v.value === this.voice.speaker);
    },
    getReaderTabs () {
      let cates = this.readerOpts.reduce((memo, { category } = {}) => {
        if (!category) {
          return memo;
        }
        let arr = [category];
        if (category.indexOf(',') > -1) {
          arr = category.split(',');
        }
        arr.forEach(v => {
          if (memo.indexOf(v) < 0) {
            memo.push(v);
          }
        })
        return memo;
      }, []) || [];
      //0: 男声  1：女声 2：童声 3:英文
      let names = ['男声', '女声', '童声', '英文', '中英混合'];
      cates = cates.sort((a, b) => a - b).map(v => {
        return {
          value: v,
          name: names[v]
        }
      });
      this.readerTabs = cates;
    },
    testPlay () {
      let el = this.$refs.audioEl;
      if (el.paused) {
        // this.$refs.audioEl.currentTime = 0;
        this.$refs.audioEl.play();
        this.playing = true;
        let h = () => {
          el.removeEventListener('ended', h);
          this.playing = false;
        }
        el.addEventListener('ended', h)
      } else {
        this.$refs.audioEl.pause();
        this.playing = false;
      }
    },
    remove () {
      this.$emit('remove');
    },
    cancelEdit () {
      this.getDur()
      this.getReaders();
      this.editing = false;
    },
    getDur () {
      if (!this.getSelectDubbing) return 0;
      return (this.getSelectDubbing.cut[1] - this.getSelectDubbing.cut[0]).toFixed(1) - 0;
    },
    updateReader (data) {
      // this.reader = data.value;
      this.readerId = data.id;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 10px;
    & .btn-edit {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      width: 105px;
      height: 30px;
      background: #5778fb;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background: #7d95f5;
      }
    }
    & .btn-remove {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 105px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #d9ddea;
      opacity: 1;
      border-radius: 4px;
      color: #737596;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.reader {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 10px 6px;
  & .figure {
    width: 26px;
    height: 26px;
    background: #d8dee9;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 6px;
  }
  & .label {
    color: #474261;
  }
}
.text-wrapper {
  margin: auto;
  width: 226px;
  min-height: 40px;
  max-height: 459px;
  background: #f8f8fb;
  opacity: 1;
  border-radius: 4px;
  padding: 11px 10px;
  color: #898d96;
  overflow: auto;
  word-break: break-all;

  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
.test-play-row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding-top: 30px;
}
.test-play {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #898d96;
  & .figure {
    margin-right: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dubbing/smartVoiceSet.vue